import { render } from "./Stap4.vue?vue&type=template&id=2ff0d7e9"
import script from "./Stap4.vue?vue&type=script&lang=js"
export * from "./Stap4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__